import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const routerMap = [
  {path: '/cn', component: () => import('@/view/cn')},
  {path: '/en', component: () => import('@/view/en')},
  {path: '*', component: () => import('@/view/cn')}
]

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: routerMap
})



// WEBPACK FOOTER //
// ./src/router.js